import { VDatePicker } from '../VDatePicker';
import { DATEPICKER_MODE } from '../VDatePicker/constant';
import { useDateNavigation, useVPeriodSelectorContext } from './hook';

export const VDatePickerField = () => {
  const { dateRangeValue, periodUnitValue, onDateRangeChange, rangePivot } =
    useVPeriodSelectorContext();
  const { handleDatePickerChange } = useDateNavigation();
  const isCustom = rangePivot.unit === 'custom';

  return (
    <VDatePicker
      className="[&_input]:w-[120px]!"
      mode={DATEPICKER_MODE.RANGE}
      disabled={!isCustom}
      size="md"
      value={dateRangeValue}
      onChange={val =>
        handleDatePickerChange(val, periodUnitValue, onDateRangeChange)
      }
    />
  );
};
